"use strict";

const _ = require('lodash');
const d3 = require('d3');
const BasicChart = require('./basic');
const legendMixin = require('./legend').legendMixin;
const layeredMixin = require('./layered').layeredMixin;

class LayeredLinesChart extends BasicChart.plug(legendMixin, layeredMixin) {
	constructor(options) {
		super(options);
	}

	initXScale() {
		return d3.scalePoint().rangeRound([0, this.options.innerWidth]).domain(this.xDomain);
	}

	calculateYDomain() {
		return [0, _(this.data).map(this.getMax).max()];
	}

	drawChart(selection) {
		// TODO: This won't work with range (min/max) domain, leaving as is for now.
		this._chart = selection;
		let byDomain = new Map();
		for (let d of this.data) {
			byDomain.set(this.getX(d), d);
		}
		let xScale = this.xScale;
		let yScale = this.yScale;
		let layers = this.layers;
		let xDomain = xScale.domain();
		let max = this._options.max || Infinity;

		for (let layer of layers) {
			let index = this.layerIndex(layer);
			let colour = this.layerColourIndex(layer);
			let line = d3.line()
				.defined(function (d) {
					return d < max;
				})
				.x(function(d) { return xScale(d); })
				.y(function (d) {
					let value = byDomain.get(d);
					return yScale((value && value[layer]) || 0) + (index * 0.1);
				});

			selection.append('g').classed('line', true)
				.append('path').attr('d', line(xDomain))
				.classed(`zl-cc-stroke-${colour}`, true);
		}
		return this._chart;
	}

	get cursor() {
		return this._cursor;
	}

	get shield() {
		return this._shield;
	}

	drawInteract(selection) {
		let self = this;
		let {innerHeight, innerWidth} = this.options;
		let xDomain = this.xDomain;
		let byDomain = this.dataByDomain;
		let xScale = this.xScale;
		let step = xScale.step();
		let node = this._chart.node();
		let legend = this._legend;
		let xFirst = xScale(xDomain[0]);
		let currentCursorPos;

		let cursor = this._cursor = selection.append('g')
			.classed('interact line', true).attr('display', 'none');
		cursor.append('path').attr('d', `M 0 ${innerHeight} L 0 0`);

		let setCursor = function setCursor() {
			let [mouseX, mouseY] = d3.mouse(node);
			let pos = Math.round((mouseX - xFirst) / step);
			pos = Math.max(0, Math.min(xDomain.length - 1, pos));
			let domainPos = xDomain[pos];
			if (domainPos !== currentCursorPos) {
				// Save new position
				currentCursorPos = domainPos;

				// Translate cursor
				let cursorX = xScale(domainPos);
				cursor.attr('transform', `translate(${cursorX},0)`);

				let d = byDomain.get(domainPos);
				if (d) {
					// Show legend
					legend.show({node: cursor.node(), data: d});
				} else {
					legend.hide();
				}
				self.emit('cm:interact', d);
			}
		};

		let shield = this._shield = selection.append('rect')
			.classed('interact reset', true)
			.attr('width', innerWidth).attr('height', innerHeight)
			.on('mouseover', function () {
				cursor.attr('display', 'inline');
				setCursor();
			})
			.on('mouseout', function () {
				cursor.attr('display', 'none');
				self.emit('cm:interact');
			})
			.on('mousemove', function () {
				setCursor();
			});

		return selection;
	}

	get dataByDomain() {
		if (!this._dataByDomain) {
			let map = this._dataByDomain = new Map();
			for (let d of this.data) {
				let k = this.getX(d);
				map.set(k, d);
			}
		}
		return this._dataByDomain;
	}

	prepareOptions(options) {
		options = super.prepareOptions(options);
		this._dataByDomain = undefined;
		return options;
	}

	draw(options) {
		super.draw(options);
		var interact = this._interact = this.canvas.append('g');
		this.drawInteract(interact);
	}
}

module.exports = LayeredLinesChart;